import { render, staticRenderFns } from "./DonutApex.vue?vue&type=template&id=c1536fc6"
import script from "./DonutApex.vue?vue&type=script&lang=js"
export * from "./DonutApex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports